<template>
  <div></div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch('user-state/clearUserData').then(() => {
      window.location = this.$router.resolve({name: 'portal-home'}).resolved.fullPath
    })
  }
}
</script>
